export const userRoles = [
  {
    label: "SOFTWARE_ENGINEER",
    value: "SOFTWARE_ENGINEER",
  },
  {
    label: "TECH_LEAD",
    value: "TECH_LEAD",
  },
  {
    label: "QA_ENGINEER",
    value: "QA_ENGINEER",
  },
  {
    label: "PROJECT_MANAGER",
    value: "PROJECT_MANAGER",
  },
  {
    label: "HUMAN_RESOURCE",
    value: "HUMAN_RESOURCE",
  },
  {
    label: "USER_EXPERIENCE",
    value: "USER_EXPERIENCE",
  },
  {
    label: "CUSTOMER_SUPPORT",
    value: "CUSTOMER_SUPPORT",
  },
];

export const userRolesAutoComplete = [
  {
    label: "SOFTWARE_ENGINEER",
    externalId: "SOFTWARE_ENGINEER",
  },
  {
    label: "TECH_LEAD",
    externalId: "TECH_LEAD",
  },
  {
    label: "QA_ENGINEER",
    externalId: "QA_ENGINEER",
  },
  {
    label: "PROJECT_MANAGER",
    externalId: "PROJECT_MANAGER",
  },
  {
    label: "HUMAN_RESOURCE",
    externalId: "HUMAN_RESOURCE",
  },
  {
    label: "USER_EXPERIENCE",
    externalId: "USER_EXPERIENCE",
  },
];
